import { SharedContent } from './shared-content';

export const InternalTransferDetailsContent = {
  pageTitle: `Tell us a few details about your internal transfer`,
  pageSubheader: `Choose the accounts you’re transferring between`,
  pageDescription: `Only the account types you selected on the previous page (joint, individual, etc.) will be displayed.`,
  aria: {
    from: `Account options`,
    to: 'Dropdown bar for transferring to accounts',
    percentValue: `Percentage value information`,
    faqAccordion: SharedContent.ariaLabels.faqAccordion,
  },
  dropdownLabel: `Showing all eligible accounts`,
  continueButton: SharedContent.buttons.continueButton,
  differentOwner: {
    dropdownText: `Someone else's Vanguard account`,
    accountName: `Name of individual (first, middle initial, last) or trust name`,
    accountNumber: `Vanguard account number(can be 8 or 11 digits)`,
    nameErrorMessage: `Valid input required`,
    numberErrorMessage: `Valid input required`,
  },
  transferFromHeader: `Transfer from`,
  fromToHeader: `What account will you be transferring from?`,
  transferToHeader: 'Transfer to',
  newAccount: 'Open a new account',
  dropdownPlaceholder: `Select an account`,
  ineligibleAccounts: 'View ineligible accounts',
  errorText: 'Make a selection to continue',
  tooBigError: `Over balance.`,
  tooLittleError: `Less than 1.`,
  estimatedAccountBalance: SharedContent.estimatedAccountBalance,
  transferMethod: {
    subHeader: `Select how you'd like to transfer`,
    description: `The following holdings are eligible for transfer based on your previous selections.`,
    labelText: `Transfer method`,
    transferMethods: [`Shares`, `Percent`],
    transferAll: `Transfer all`,
    percentValue: `Percent value`,
    percentageToolTip: `This value will apply to all selected investments`,
  },
  transferHoldings: {
    tableError: `At least one of these investments must have an input value greater than zero.`,
    bannerMessage: `As an advised client, your transfer may trigger a rebalance on your account to keep your portfolio's asset mix in line with your goals. The rebalance may result in a taxable event.`,
  },
  faqAccordion: [
    {
      title: `Can I transfer dollars or shares using Spec ID?`,
      content: `To transfer shares or dollars using Spec ID, you'll need to complete the process elsewhere. <INTELLEDOX_LINK>, or call us at 877-662-7447 Monday through Friday, 8 a.m. to 8 p.m., Eastern time for assistance.`,
    },
    {
      title: `What if I'm trying to transfer bonds?`,
      content: `Due to the complexity of bond limits, all bond transfers need to be completed using another process. You can <INTELLEDOX_LINK_MIDSENTENCE>, or call us at 877-662-7447 Monday through Friday, 8 a.m. to 8 p.m., Eastern time. Please note the progress of this request will not be saved if you choose to leave. We encourage you to finish transferring your other investments before beginning your bond transfer.`,
    },
  ],
  faqLinks: {
    faqCapitalized: `Begin the process online`,
    faqLowerCase: `begin the process online`,
  },
  totalEstAmount: 'total est. amount',
  divorceFlow: {
    toDescription: `The receiving Vanguard account must be the same type as the one you are transferring assets from.`,
    nextSection: {
      title: `Next up:`,
      text: `Review holdings`,
    },
  },
  orgTransfer: {
    vcOnlyLabel: `** Only list Vanguard Charitable accounts **`,
    noEligibleOrgAccountBanner: `You don't have an eligible organization account to receive these assets.`,
  },
};
